<template>
  <v-container fluid class="grey lighten-5">
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: 'App',

  mounted() {
    document.addEventListener('copy', this.bloquearCopiar)
    document.addEventListener('cut', this.bloquearCopiar)
    document.addEventListener('contextmenu', this.bloquearClickDerecho)
    document.addEventListener('keydown', this.bloquearTeclas)
  },

  beforeDestroy() {
    document.removeEventListener('copy', this.bloquearCopiar)
    document.removeEventListener('cut', this.bloquearCopiar)
    document.removeEventListener('contextmenu', this.bloquearClickDerecho)
    document.removeEventListener('keydown', this.bloquearTeclas)
  },

  methods: {
    bloquearCopiar(event) {
      event.preventDefault()
    },

    bloquearClickDerecho(event) {
      event.preventDefault()
    },

    bloquearTeclas(event) {
      const tecla = event.key.toLowerCase()

      if (
        (event.ctrlKey || event.metaKey) &&
        ['c', 'x', 'a', 's', 'p'].includes(tecla)
      ) {
        event.preventDefault()
      }
    }
  }
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.no-copy {
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>